import React from "react";

/**
 * Renders text content with clickable links
 */
export function renderTextWithLinks(text: string, {
  isPatient = false,
  isOwnMessage = false
}: {
  isPatient?: boolean;
  isOwnMessage?: boolean;
} = {}): React.ReactNode {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/;
  const parts = text.split(urlRegex);
  const linkColor = isPatient ? "text-white hover:text-gray-200" : isOwnMessage ? "text-primary-foreground hover:text-primary-foreground/80" : "text-primary hover:text-primary/80";
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Remove trailing punctuation from URLs
      const cleanUrl = part.replace(/[.,;:!?]+$/, "");
      const trailingPunctuation = part.slice(cleanUrl.length);
      try {
        // Use URL constructor for more robust URL handling
        let url: URL;
        if (cleanUrl.startsWith("http")) {
          url = new URL(cleanUrl);
        } else {
          url = new URL(`https://${cleanUrl}`);
        }
        return <span key={index}>
            <a href={url.href} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className={`cursor-pointer font-semibold underline ${linkColor}`}>
              {cleanUrl}
            </a>
            {trailingPunctuation}
          </span>;
      } catch {
        // If URL parsing fails, return the text as-is
        return part;
      }
    }
    return part;
  });
}